import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon } from 'lucide-react';
const HeaderCPAPInvestigation = () => {
  return <header className="bg-white" data-id="element-3391">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-3392"></div>
      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-3393">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-3394">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-3395">
            MEDPRESS GAZETTE
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-3396">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>
        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-3397">
          <div className="text-left" data-id="element-3398">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-3399">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-3400">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>
      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-3401">
        <div className="max-w-4xl mx-auto" data-id="element-3402">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-3403">
            INVESTIGATIVE REPORT
          </div>
          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-5" data-id="element-3404">
            Nurse Practitioner Investigates: Do 'Ergonomic' CPAP Pillows Actually 
            Work, or Is It Another Wellness Scam?
          </h1>
          <div className="flex items-start mb-5 border-b border-gray-200 pb-5" data-id="element-3405">
            <div className="w-14 h-14 overflow-hidden rounded-full flex-shrink-0 mr-4 border border-gray-300" data-id="element-3406">
              <img src="https://cdn.magicpatterns.com/uploads/egKKwrk3tzHFmvy5Ud9ZH3/1.png" alt="Lisa Wang" className="w-full h-full object-cover" data-id="element-3407" />
            </div>
            <div className="flex-1" data-id="element-3408">
              <div className="flex items-center" data-id="element-3409">
                <div className="font-medium text-gray-900 text-lg" data-id="element-3410">
                  By Lisa Wang, RN, MSN 
                </div>
                <div className="ml-2 flex items-center text-blue-600" data-id="element-3411">
                  <CheckCircleIcon className="h-4 w-4" data-id="element-3412" />
                  <span className="text-xs ml-1 font-medium" data-id="element-3413">Verified</span>
                </div>
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-3414">
                Former Head of Integrative Medicine, Cedar Sinai Medical Center
              </div>
              <div className="flex text-xs text-gray-500 items-center" data-id="element-3415">
                <div className="flex items-center mr-4" data-id="element-3416">
                  <ClockIcon className="h-3 w-3 mr-1" data-id="element-3417" />
                  <span data-id="element-3418">11 min read</span>
                </div>
                <div className="flex items-center" data-id="element-3419">
                  <EyeIcon className="h-3 w-3 mr-1" data-id="element-3420" />
                  <span data-id="element-3421">24,867 views</span>
                </div>
              </div>
            </div>
          </div>
          <p className="font-serif text-gray-700 text-base sm:text-lg mb-6 leading-relaxed border-l-4 border-gray-300 pl-4 italic" data-id="element-3422">
            After 30 years in medicine, I've seen every "miracle cure" come and go. 
            So when I found out about "ergonomic" CPAP pillows, I decided to run a 
            6-month investigation. What I discovered will save you hundreds of dollars 
            – and might actually fix your CPAP therapy.
          </p>
          <div className="border-t border-gray-200 pt-3 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-3423">
            <div className="mb-1 flex items-center" data-id="element-3424">
              <span className="font-medium mr-2" data-id="element-3425">Published by:</span>
              MedPress Gazette Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-3426">
              <span className="font-medium mr-2" data-id="element-3427">Published:</span>
              {(() => {
              const yesterday = new Date();
              yesterday.setDate(yesterday.getDate() - 1);
              return yesterday.toLocaleDateString('en-US', {
                month: 'long',
                year: 'numeric'
              });
            })()}
            </div>
          </div>
        </div>
      </div>
      {/* Author image */}
      <div className="px-4 sm:px-8 py-2 border-b border-gray-200" data-id="element-3428">
        <div className="max-w-4xl mx-auto" data-id="element-3429">
          <div className="sm:flex items-center" data-id="element-3430">
            <div className="sm:w-1/3 mb-4 sm:mb-0 sm:mr-6" data-id="element-3431">
              <img src="https://cdn.magicpatterns.com/uploads/egKKwrk3tzHFmvy5Ud9ZH3/1.png" alt="Lisa Wang, RN, MSN in hospital corridor" className="w-full rounded-lg shadow-md" data-id="element-3432" />
            </div>
            <div className="my-4 border-l-4 border-gray-800 pl-6 py-4 bg-gradient-to-r from-gray-100 to-white shadow-sm" data-id="element-3433">
              <p className="text-sm tracking-wide text-gray-900 mb-2" data-id="element-3434">
                <span className="font-bold" data-id="element-3435">Lisa Wang, RN, MSN</span> has 
                spent three decades in clinical practice specializing in 
                integrative medicine approaches. As the former Head of 
                Integrative Medicine at Cedar Sinai Medical Center, she has 
                evaluated hundreds of wellness products and alternative 
                treatments throughout her career.
              </p>
              <p className="text-sm tracking-wide text-gray-900 mb-2" data-id="element-3436">
                Her investigative work focuses on separating evidence-based 
                treatments from marketing hype, helping patients make informed 
                health decisions based on scientific testing rather than trends.
              </p>
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default HeaderCPAPInvestigation;